import { schema, types } from 'papr'
const ALLOWED_ERRORS = ['bad_credentials' as const, 'other' as const]

export const githubBackupSchema = schema(
	{
		user: types.objectId(),
		publication: types.objectId(),
		githubUsername: types.string({ required: true }),
		accessToken: types.string(),
		installationId: types.string(),
		owner: types.string({ required: true }),
		repository: types.string({ required: true }),
		dateAdded: types.date({ required: true }),
		isActive: types.boolean({ required: true }),
		error: types.enum(ALLOWED_ERRORS),
	},

	{
		timestamps: true,
		defaults: {
			isActive: true,
		},
	},
)

export type GitHubBackupDocument = (typeof githubBackupSchema)[0]
export type GitHubBackupSchemaOptions = (typeof githubBackupSchema)[1]

export type GitHubErrors = (typeof ALLOWED_ERRORS)[number]
